import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';
import SmallIcon from 'components/atoms/SmallIcon/SmallIcon';
import SpanText from 'components/atoms/SpanText/SpanText';
import homeIcon from 'assets/images/svg/homeIcon.svg';
import phoneIcon from 'assets/images/svg/phoneIcon.svg';
import emailIcon from 'assets/images/svg/emailIcon.svg';

const ContactLink = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  text-align: center;
  text-decoration: none;
  color: ${({ theme }) => theme.black};
  cursor: pointer;
`;

const ContactInfo = () => {
  const data = useStaticQuery(graphql`
    {
      datoCmsContact {
        street
        city
        phonehref
        phone
        emailhref
        email
      }
    }
  `);

  const { street, city, phoneHref, phone, emailHref, email } = data.datoCmsContact;
  const mapsHref = `https://www.google.com/maps?q=${encodeURIComponent(`${street} ${city}`)}`;
  const telHref = phoneHref?.startsWith('tel:') ? phoneHref : `tel:${phoneHref || phone}`;
  const mailHref = emailHref?.startsWith('mailto:') ? emailHref : `mailto:${emailHref || email}`;

  return (
    <>
      <ContactLink href={mapsHref} target="_blank" rel="noopener noreferrer">
        <SmallIcon icon={homeIcon} />
        <SpanText>
          {street}
          <br />
          {city}
        </SpanText>
      </ContactLink>

      <ContactLink href={telHref}>
        <SmallIcon icon={phoneIcon} />
        <SpanText>{phone}</SpanText>
      </ContactLink>

      <ContactLink href={mailHref}>
        <SmallIcon icon={emailIcon} />
        <SpanText>{email}</SpanText>
      </ContactLink>
    </>
  );
};

export default ContactInfo;
